export default __webpack_public_path__ + "static/media/self-pic.782c642f.png";